import { PromoConditionTypeConfig } from '~/services/PromoService';

export function getValidatedConditionApplyType(
  conditionType: string | undefined,
  currentApplyType: string | undefined,
  promoCodeConditionTypeConfig: Array<PromoConditionTypeConfig>,
  alwaysReset = false,
): string | undefined {
  if (!conditionType) {
    return undefined;
  }

  const config = promoCodeConditionTypeConfig.find((ct) => ct.key === conditionType);
  if (!config || !config.conditionApplyTypes || config.conditionApplyTypes.length === 0) {
    return undefined;
  }

  if (alwaysReset) {
    return config.conditionApplyTypes[0];
  }

  if (!currentApplyType || !config.conditionApplyTypes.includes(currentApplyType)) {
    return config.conditionApplyTypes[0];
  }

  return currentApplyType;
}
